// // src/components/Register.jsx
// import React, { useEffect, useRef } from "react";
// import "./Register.css";
// import { useLogin } from "../LoginProvider";

// export default function Register({ isOpen, onClose, onSwitch }) {
//   const dialogRef = useRef(null);
//   const { registerEmail, loading, error, setError } = useLogin();

//   useEffect(() => {
//     if (!isOpen) return;
//     const firstInput = dialogRef.current?.querySelector("input");
//     firstInput?.focus();
//     const onKey = (e) => e.key === "Escape" && onClose?.();
//     document.addEventListener("keydown", onKey);
//     return () => document.removeEventListener("keydown", onKey);
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     const data = new FormData(e.currentTarget);
//     const payload = {
//       name: data.get("name"),
//       email: data.get("email"),
//       phone: data.get("phone") || "",
//       password: data.get("password"),
//     };

//     const user = await registerEmail(payload);
//     if (user) onClose?.();
//   };

//   return (
//     <div className="modal-overlay" onClick={onClose} aria-modal="true" role="dialog">
//       <div className="modal" onClick={(e) => e.stopPropagation()} ref={dialogRef}>
//         <button className="modal-close" aria-label="Fermer" onClick={onClose}>×</button>

//         <img src="/images/dollarstore.jpg" alt="Dollar Store" className="logo-img-login" />
//         <h2 className="modal-title">Créer un compte</h2>

//         <form className="form" onSubmit={handleSubmit}>
//           <label className="field">
//             <span>Nom</span>
//             <input type="text" name="name" placeholder="Votre nom" required minLength={2} />
//           </label>

//           <label className="field">
//             <span>E-mail</span>
//             <input type="email" name="email" placeholder="vous@exemple.com" required />
//           </label>

//           <label className="field">
//             <span>Téléphone (optionnel)</span>
//             <input type="tel" name="phone" placeholder="+228…" inputMode="tel" />
//           </label>

//           <label className="field">
//             <span>Mot de passe</span>
//             <input type="password" name="password" placeholder="Au moins 6 caractères" required minLength={6} />
//           </label>

//           <button className="submit" type="submit" disabled={loading}>
//             {loading ? "Inscription..." : "S’inscrire"}
//           </button>

//           {error && <div style={{ color: "#dc2626", marginTop: 8, fontSize: 14 }}>{error}</div>}
//         </form>

//         <p className="switch">
//           Déjà un compte ?{" "}
//           <button className="link" type="button" onClick={() => onSwitch?.("login")}>
//             Se connecter
//           </button>
//         </p>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useRef, useState } from "react";
import "./Register.css";
import { useLogin } from "../LoginProvider";

export default function Register({ isOpen, onClose, onSwitch }) {
  const dialogRef = useRef(null);
  const { registerEmail, loading, error, setError } = useLogin();

  // 👉 état pour la checkbox
  const [hasForeignCode, setHasForeignCode] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const firstInput = dialogRef.current?.querySelector("input");
    firstInput?.focus();
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   const data = new FormData(e.currentTarget);
  //   const payload = {
  //     name: data.get("name"),
  //     email: data.get("email"),
  //     phone: data.get("phone") || "",
  //     password: data.get("password"),
  //     foreignCode: hasForeignCode ? data.get("foreignCode") : null, 
  //   };

  //   const user = await registerEmail(payload);
  //   if (user) onClose?.();
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  const data = new FormData(e.currentTarget);
  const payload = {
    name: data.get("name"),
    email: data.get("email"),
    phone: data.get("phone") || "",
    password: data.get("password"),
    foreignCode: hasForeignCode ? data.get("foreignCode") : null,
  };

  const user = await registerEmail(payload);

  if (user) {
    // Ferme la modale ou pop-up
    onClose?.();

    // ✅ Envoi d'une notification WhatsApp
    //const message = `🆕 *${payload.name}* vient de s'inscrire sur la plateforme.`;

    try {
      // await fetch("/api/send-whatsapp", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     to: "+22890045926", // ton numéro admin
      //     text: message,
      //   }),
      // });
      //console.log("✅ Notification WhatsApp envoyée pour nouvelle inscription !");
    } catch (err) {
     // console.error("Erreur envoi WhatsApp :", err);
    }
  } else {
    setError("Erreur lors de l'inscription. Veuillez réessayer.");
  }
};


  return (
    <div className="modal-overlay" onClick={onClose} aria-modal="true" role="dialog">
      <div className="modal" onClick={(e) => e.stopPropagation()} ref={dialogRef}>
        <button className="modal-close" aria-label="Fermer" onClick={onClose}>×</button>

        <img src="/images/dollarstore.jpg" alt="Dollar Store" className="logo-img-login" />
        <h2 className="modal-title">Créer un compte</h2>

        <form className="form" onSubmit={handleSubmit}>
          <label className="field">
            <span>Nom</span>
            <input type="text" name="name" placeholder="Votre nom" required minLength={2} />
          </label>

          <label className="field">
            <span>E-mail</span>
            <input type="email" name="email" placeholder="vous@exemple.com" required />
          </label>

          <label className="field">
            <span>Téléphone </span>
            <input type="tel" name="phone" placeholder="+228…" inputMode="tel" />
          </label>

          <label className="field">
            <span>Mot de passe</span>
            <input type="password" name="password" placeholder="Au moins 6 caractères" required minLength={6} />
          </label>

          {/* 👉 Checkbox pour activer le champ foreignCode */}
          <label className=" checkbox-field">
            <input
              type="checkbox"
              checked={hasForeignCode}
              onChange={(e) => setHasForeignCode(e.target.checked)}
            />
            <span>J’ai un code d'invitation</span>
          </label>

          {/* 👉 Affiche l’input seulement si la checkbox est cochée */}
          {hasForeignCode && (
            <label className="field">
              <span>Code d'invitation</span>
              <input type="text" name="foreignCode" placeholder="Saisissez votre code" />
            </label>
          )}

          <button className="submit" type="submit" disabled={loading}>
            {loading ? "Inscription..." : "S’inscrire"}
          </button>

          {error && <div style={{ color: "#dc2626", marginTop: 8, fontSize: 14 }}>{error}</div>}
        </form>

        <p className="switch">
          Déjà un compte ?{" "}
          <button className="link" type="button" onClick={() => onSwitch?.("login")}>
            Se connecter
          </button>
        </p>
      </div>
    </div>
  );
}
